<template>
    <div>
        <transition name="fade">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    export default {

        watch: {
            '$route': 'configurePage'
        },

        mounted() {
            this.configurePage();
        },

        methods: {
            configurePage() {
                this.$emit('set-action-bar', {
                    title: this.$t('schedules'),
                    buttons: [
                        {
                            icon: 'plus',
                            link: '/clients/schedules/new'
                        }
                    ]
                });
            }
        }

    }
</script>